import React from 'react';
import { StyledDivider } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const Divider = ({ className, orientation, margin, ...rest }) => {
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    const roleProp = a11yProps['role'] ?? 'separator';
    return (React.createElement(StyledDivider, { ...a11yProps, ...dataProps, role: roleProp, "$orientation": orientation, className: className, margin: margin, "aria-orientation": orientation }));
};
Divider.displayName = 'Divider';
//# sourceMappingURL=index.js.map